export default "__VITE_ASSET__5cdbfa20__"